import { type BasePerformanceRequestFilterParams } from "features/Library/Common/models";
import { sendExportRequest } from "features/Library/Common/utils/performanceUtils";
import { threatDefenseReportingService } from "../services/threatDefenseReportingService";

export const getThreatDefenseCampaignExport = (params: BasePerformanceRequestFilterParams, campaignName: string) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => threatDefenseReportingService.getThreatDefenseCampaignExport(params),
    campaignName,
    abortController,
  );
};

export const getThreatDefenseRemedialTrainingExport = (
  params: BasePerformanceRequestFilterParams,
  campaignName: string,
) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => threatDefenseReportingService.getThreatDefenseRemedialTrainingExport(params),
    campaignName,
    abortController,
  );
};
